import { Layout } from '@/components/Layout/Layout';
import { getPathTranslation } from '@/service/localization/getPathTranslations';
import ClientInspirationTipsAndTricksPage from 'components/PageLevelComponents/ClientInspirationTipsAndTricksPage';
import { ANONYMOUS_TOKEN_NAME, LOCALE_DEFAULT } from 'config/config';
import type { GetServerSideProps } from 'next';
import { TipsAndTricksController } from 'server/controller/page/inspiration/tipsAndTricksPageController';
import type { ITipsAndTricksPageResource } from 'server/resource/page/tipsAndTricksPageResource';

export default function Page(props: ITipsAndTricksPageResource) {
  const {
    metaData,
    followUsData,
    breadcrumbsCMSData,
    difficultyCopy,
    searchOverlayData,
    relatedRecipes,
    relatedTipsAndTricks,
    footerNavData,
    footerImage,
    countrySelectorData,
    newsletterData,
    contactUsUrl,
    getHeaderNav,
    getMobileNavData,
    popularSearchData,
    cardCarouselCMSData,
    recallData,
    locale,
    tipAndTrick,
    tipsAndTricksData,
    pathTranslations,
    userToken,
    globalDictionary,
    currentUrl,
  } = props;

  return (
    <Layout
      themeName={undefined}
      pathTranslations={pathTranslations}
      locale={locale}
      globalMetadata={metaData}
      getHeaderNav={getHeaderNav}
      getMobileNavData={getMobileNavData}
      popularSearchData={popularSearchData}
      footerNavData={footerNavData}
      footerImage={footerImage}
      searchOverlayData={searchOverlayData}
      countrySelectorData={countrySelectorData}
      newsletterData={newsletterData}
      contactUsUrl={contactUsUrl}
      difficultyCopy={difficultyCopy as Record<string, string>}
      cardCarouselCMSData={cardCarouselCMSData}
      recallData={recallData}
      userToken={userToken}
      globalDictionary={globalDictionary}
    >
      <ClientInspirationTipsAndTricksPage
        breadcrumbsCMSData={breadcrumbsCMSData}
        followUsData={followUsData}
        relatedRecipes={relatedRecipes}
        relatedTipsAndTricks={relatedTipsAndTricks}
        tipAndTrick={tipAndTrick}
        tipsAndTricksData={tipsAndTricksData}
        currentUrl={currentUrl}
      />
    </Layout>
  );
}

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  params,
  defaultLocale,
  resolvedUrl,
  req,
}) => {
  const anonymousToken = req.cookies[ANONYMOUS_TOKEN_NAME];

  const host = req?.headers.host || '';
  const protocol = (req.headers['x-forwarded-proto'] as string) || 'https';

  const translatedPart = getPathTranslation(locale!, 'tipsAndTricks');
  const translatedPartExploded = translatedPart.split('/');
  const resolvedUrlExploded = resolvedUrl.split('/');
  resolvedUrlExploded[1] = translatedPartExploded[0];
  resolvedUrlExploded[2] = translatedPartExploded[1];

  const currentUrl = `${protocol}://${host}${resolvedUrlExploded.join('/')}`;
  const result = await TipsAndTricksController.getCachedTipsAndTricksPageData({
    resolvedUrl,
    locale: locale || defaultLocale || LOCALE_DEFAULT,
    slug: Array.isArray(params?.slug) ? params.slug.join('/') : (params?.slug ?? ''),
    userToken: anonymousToken ?? '',
  });

  return { props: { ...result.props, currentUrl } };
};
